import React, { useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { CommonProperties, CommonStyles, Color } from '../styles';
import { useSelector } from 'react-redux';
import { formatCurrency } from '../utils/currency.utils';
import GroupSummaryList from './tripSummary/GroupSummaryList';
import BaseText from './BaseText';
import { scale } from '../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
import RowView from './RowView';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../store/selectors/auth.selector';
import { selectTotalCartAmount } from '../store/selectors/cart.selector';
import { AA_ENABLED } from '../config/env';
const TripSummary = ({ changeResData, changeResFare }) => {
  const { t } = useTranslation(i18nNS.checkout);
  const { tKey } = useComponentTKey('TripSummary');
  const tripSummary = useSelector((state) => state && state.search && state.search.tripSummary);
  const [taxes, setTaxes] = useState(0);
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  const cartTotal = useSelector(selectTotalCartAmount);
  useEffect(() => {
    if (tripSummary) {
      let tax = 0;

      if (Array.isArray(tripSummary.HotelResponses)) {
        tripSummary.HotelResponses.forEach((i) => {
          tax += i.TaxTotalDays;
        });
      }

      if (Array.isArray(tripSummary.CarResponses)) {
        tripSummary.CarResponses.forEach((i) => {
          tax += i.TotalTax;
        });
      }

      setTaxes(tax);
    }
  }, [tripSummary]);

  return (
    <View style={CommonStyles.flex1}>
      {changeResData && (
        <>
          <BaseText style={styles.tripText}>Original Trip</BaseText>
          <GroupSummaryList
            // railList={tripSummary.RailResponses}
            airList={[changeResData.AirResponseDetails]}
            // hotelList={tripSummary.HotelResponses}
            // carList={tripSummary.CarResponses}
          />
        </>
      )}
      {tripSummary && (
        <>
          {changeResData && <BaseText style={styles.tripText}>Updated Iternary</BaseText>}
          <GroupSummaryList
            railList={tripSummary.RailResponses}
            airList={tripSummary.AirResponses}
            hotelList={tripSummary.HotelResponses}
            carList={tripSummary.CarResponses}
            currency={currency}
            currencyCulture={currencyCulture}
            redeem={tripSummary.IsRedeem}
          />
          <View style={styles.border} />
          {!changeResData ? (
            <View>
              {taxes !== 0 && (
                <View style={styles.taxWrap}>
                  <BaseText>{t(tKey('AdditionalTaxes'))}</BaseText>
                  <BaseText>{formatCurrency(taxes, currency, currencyCulture)}</BaseText>
                </View>
              )}

              <View style={styles.totalContainer}>
                <View style={styles.totalWrap}>
                  <BaseText style={styles.h2}>{t(tKey('Total'))}</BaseText>
                  <BaseText numberOfLines={2} style={styles.includeText}>
                    {AA_ENABLED ? 'taxes and carrier-imposed fees' : t(tKey('InclTaxes'))}
                  </BaseText>
                </View>
                {tripSummary.IsRedeem ? (
                  <BaseText style={CommonStyles.h1}>
                    {tripSummary && tripSummary.AirResponses[0].RedeemPoints + ' pts'}
                  </BaseText>
                ) : (
                  <BaseText style={CommonStyles.h1}>
                    {tripSummary && formatCurrency(cartTotal, currency, currencyCulture)}
                  </BaseText>
                )}
              </View>
            </View>
          ) : (
            <>
              {changeResFare && !tripSummary?.ChangeTripViewModel?.ExchangePriceRQError ? (
                <View style={CommonStyles.mt2}>
                  <RowView style={CommonStyles.mb3}>
                    <BaseText style={styles.key}>Total base cost of all travel: </BaseText>
                    <BaseText style={styles.value}>${changeResFare?.TotalBaseFare}</BaseText>
                  </RowView>
                  <RowView style={CommonStyles.mb3}>
                    <BaseText style={styles.key}>Exchange fee: </BaseText>
                    <BaseText style={styles.value}>${changeResFare?.PenaltyAmount}</BaseText>
                  </RowView>
                  <RowView style={CommonStyles.mb3}>
                    <BaseText style={styles.key}>Less ticketed amount: </BaseText>
                    <BaseText style={styles.value}>${changeResFare?.ValueOldTicket}</BaseText>
                  </RowView>
                  <RowView style={CommonStyles.mb3}>
                    <BaseText style={styles.key}>Taxes & fees: </BaseText>
                    <BaseText style={styles.value}>${changeResFare?.TotalTax}</BaseText>
                  </RowView>
                  <RowView style={CommonStyles.mb3}>
                    <BaseText style={styles.totalKey}>Total: </BaseText>
                    <BaseText style={[styles.value, styles.total]}>
                      ${changeResFare?.TotalFair}
                    </BaseText>
                  </RowView>
                  <RowView style={CommonStyles.mb3}>
                    <BaseText style={styles.key}>Amount charged to card today: </BaseText>
                    <BaseText style={styles.value}>${changeResFare?.TotalFair}</BaseText>
                  </RowView>
                </View>
              ) : (
                <BaseText style={styles.textError}>
                  {tripSummary?.ChangeTripViewModel?.ExchangePriceRQError}
                </BaseText>
              )}
            </>
          )}
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  tripText: {
    textAlign: 'center',
    ...CommonProperties.h4,
  },
  key: {
    flex: 1,
    textAlign: 'right',
    ...CommonProperties.mr2,
    ...CommonProperties.body,
  },
  value: {
    flex: 1,
    ...CommonProperties.body,
    ...CommonProperties.h3,
  },
  total: {
    color: Color.primary,
    ...CommonProperties.h2,
  },
  totalKey: {
    flex: 1,
    textAlign: 'right',
    ...CommonProperties.mr2,
    ...CommonProperties.mt1,
    ...CommonProperties.body,
  },
  h2: {
    ...CommonProperties.h2,
    ...CommonProperties.mr2,
  },
  includeText: {
    width: scale(95),
    color: 'rgba(0,0,0,.8)',
    ...CommonProperties.xxSmall,
  },
  taxWrap: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...CommonProperties.py2,
  },
  totalWrap: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textError: {
    color: Color.required,
  },
  totalContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: scale(50),
    ...CommonProperties.py2,
  },
  border: {
    borderTopColor: 'gray',
    borderTopWidth: 0.5,
  },
});

export default TripSummary;
